module.exports = "/assets/data/1d85589e32cb82206c758889be9b4522-M2.data.json";